import { __extends } from "tslib";
import { IgrNumericYAxis } from "./igr-numeric-y-axis";
import { PercentChangeYAxis } from "./PercentChangeYAxis";
/**
 * A horizontal axis that uses a DateTime scale.
*
* You can use the `IgrPercentChangeYAxis` show percentage values.
*
* ```ts
* <IgrDataChart
*     dataSource={this.state.dataSource}
*     width="700px"
*     height="500px">
*
*     <IgrPercentChangeYAxis name="yAxis" />
*  </IgrDataChart>
* ```
*/
var IgrPercentChangeYAxis = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrPercentChangeYAxis, _super);
    function IgrPercentChangeYAxis(props) {
        return _super.call(this, props) || this;
    }
    IgrPercentChangeYAxis.prototype.createImplementation = function () {
        return new PercentChangeYAxis();
    };
    Object.defineProperty(IgrPercentChangeYAxis.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    return IgrPercentChangeYAxis;
}(IgrNumericYAxis));
export { IgrPercentChangeYAxis };
